import { Outlet } from 'react-router'

const RefundMainLayout = () => {
  return (
    <Outlet />
  )
}

export default RefundMainLayout